function initLoopCustomWidget(productId){
    const initialVariantId = getSelectedVariantId(productId);
   showWidgetForVariant(initialVariantId); 
   observeFormForVariantChangeLoop(window.productData);
}

function getSelectedVariantId(productId){
  let selectedVariantId = getVariantIdFromURLLoop(window.productData?.variants) || window.productData?.variants[0]?.id;
  console.log('selectedVariantId>>', selectedVariantId);
  return selectedVariantId;
}

function getVariantIdFromURLLoop(variants) {
    const currentPageUrl = document.URL;
    const url = new URL(currentPageUrl);
    const variantIdFromUrl = url.searchParams.get("variant") || "";
    const variantIdSet = new Set(variants?.map((v) => v.id));
    return variantIdSet.has(Number(variantIdFromUrl)) ? variantIdFromUrl : null;
}

  function showWidgetForVariant(selectedVariantId) {
    const selectedVariantElement = document.querySelector(`#variant-${selectedVariantId}`);
    console.log('selectedVariantElement>>', selectedVariantElement);
      if (selectedVariantElement){
        selectedVariantElement.style.display = 'block';
        toInsertSellingPlan(selectedVariantId, selectedVariantElement)
      } else {
        selectedVariantElement.style.display = 'none';
      }
  }

function toInsertSellingPlan(selectedVariantId, selectedVariantElement){
    const checkbox = selectedVariantElement.querySelector('input[type="checkbox"]');
    const frequencyWrap = selectedVariantElement.querySelector('.loop-frequency-wrap');
    const sellingPlanInput = document.getElementById('selling-plan-input');
  
    const pdpPriceContainer = document.querySelector('.zpa-product-price');
    const innerPriceConatiner = pdpPriceContainer.querySelector('.zpa-el-product-price');
    const actualPriceContainer = innerPriceConatiner.querySelector('.zpa-inline-block');
  
    const variantObj = window.productData.variants.find(v => v.id == selectedVariantId);
  
    if (checkbox && frequencyWrap) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          frequencyWrap.style.display = 'block';
            
            console.log('variantObj>>', variantObj);
            if (variantObj && variantObj.selling_plan_allocations) {
              sellingPlanInput.value = variantObj.selling_plan_allocations[0].selling_plan_id;
            }
            if(actualPriceContainer){
            actualPriceContainer.innerHTML = loopWidgetFormatPrice(variantObj.selling_plan_allocations[0].per_delivery_price);
            }  
                 
        } else {
          frequencyWrap.style.display = 'none';
          sellingPlanInput.value = '';
          
          if(actualPriceContainer){
            actualPriceContainer.innerHTML = loopWidgetFormatPrice(variantObj.price);
            }
        }
      });
    }
  }

function loopWidgetFormatPrice(value) {
    const { locale, country } = window.Shopify;
    const { active: currency } = window.Shopify.currency;
    const decimalValue = value / 100;

    const options = {
        style: "currency",
        currency,
    };

    const formattedLocale = locale?.includes("-") ? locale : `${locale}-${country}`;
    return new Intl.NumberFormat(formattedLocale, options).format(decimalValue);
}

function observeFormForVariantChangeLoop(productData) {
    document.querySelectorAll("form").forEach((form) => {
        const variantElement = form.querySelector('[name="id"]');
        const loopVariantElement = form.querySelector(
            '[name="loop_variant_id"]'
        );
        if (loopVariantElement && variantElement?.value) {
            loopVariantElement.value = variantElement.value;
        }

        const variantIdSet = new Set(productData?.variants?.map((v) => v.id));
        if (
            variantElement?.value &&
            variantIdSet.has(Number(variantElement?.value))
        ) {
            const config = {
                attributes: true,
                childList: true,
                subtree: true,
            };

            const callback = (mutationsList, observer) => {
                const variantId = variantElement?.value ?? "";
                const loopVariantElementId = loopVariantElement?.value ?? "";
                if (
                    variantId &&
                    loopVariantElement &&
                    variantId !== loopVariantElementId
                ) {
                    loopVariantElement.value = variantId;
                    onVariantChange(variantId);
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(form, config);
        }
    });
}

function onVariantChange(variantId){
  hidePreviousVariantWidget(variantId);
  resetInputSellingPlanValue(variantId);
  showWidgetForVariant(variantId);
}

function hidePreviousVariantWidget(variantId) {
  const allVariantWidgetContainer = document.querySelectorAll('.loop-custom-subscription-variant');

  allVariantWidgetContainer.forEach(container => {
    const containerVariantId = container.id.split('variant-')[1]; // Extract variant ID from id="variant-xxxx"
    console.log('containerVariantId>>', containerVariantId);
      container.style.display = 'none';   // Hide others
    // resetCheckboxSlection(container);
    const selectedCheckbox = container.querySelector('input[type="checkbox"]');
    if (selectedCheckbox) {
      selectedCheckbox.checked = false; // Uncheck the checkbox
    }
  });
}


function resetInputSellingPlanValue(){
  const sellingPlanInput = document.getElementById('selling-plan-input');
  sellingPlanInput.value = null;
}


function applyLoopCustomStyles() {
    const customStyles = `
        <style id="loop-custom-overrides">
            /* Override Loop app styles */
            .loop-btn-size-lg {
                font-size: 16px !important;
            }

        </style>
    `;

    const existingStyles = document.getElementById('loop-custom-overrides');
    if (existingStyles) {
        existingStyles.remove();
    }
    
    document.head.insertAdjacentHTML('beforeend', customStyles);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLoopCustomStyles);
} else {
    applyLoopCustomStyles();
}
